import React, { Component } from 'react'
import { getPageData } from '../utils/helpers'
import { PageWrapper, Hero } from '../components/sections'
import { telNumber, emailAddress, officeNumber } from '../utils/variables'
import ContactInfo from '../components/contact/ContactInfo'
import IconPhone from '../assets/images/icon-blue-phone.svg'
import IconMail from '../assets/images/icon-blue-envelope.svg'
import IconMapPin from '../assets/images/icon-blue-map-pin.svg'
import ImageMap from '../assets/images/image-map.jpg'
import HeroImg from '../assets/images/hero-contact.jpeg'

class PageContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollDiv: 'contact-details',
    }
  }

  onButtonClick() {
    scrollToDiv(this.state.scrollDiv)
  }

  render() {
    const { scrollDiv } = this.state
    const { data } = this.props
    const wp = getPageData(data, 'Contact')
    return (
      <PageWrapper page="contact">
        <Hero
          page="contact"
          data={{
            ...wp,
            hero_background: {
              localFile: {
                childImageSharp: {
                  sizes: {
                    originalImg: HeroImg,
                  },
                },
              },
            },
          }}
          scrollTo={scrollDiv}
        />
        <section className="contact" id="contact-details">
          <div className="contact__row">
            <div className="contact__text-col">
              <h2 className="title">Get In Touch</h2>
              <p className="text">
                Please call us to discuss your cleaning project with us. We’ll
                be sure to get back to you as soon as possible.
              </p>
              <div className="contact__info-group">
                <ContactInfo
                  variant="phone"
                  icon={IconPhone}
                  text={`${telNumber} or ${officeNumber}`}
                  // url={`tel:${telNumber}`}
                />
                <ContactInfo
                  variant="email"
                  icon={IconMail}
                  text={emailAddress}
                  url={`mailto:${emailAddress}`}
                />
              </div>
            </div>
            <div className="contact__image-wrapper">
              <img
                className="contact__image-pin"
                src={IconMapPin}
                alt="Map Pin"
              />
              <img
                className="contact__image"
                src={ImageMap}
                alt="Map of Basingstoke"
              />
            </div>
          </div>
        </section>
      </PageWrapper>
    )
  }
}

export default PageContact

export const queryContactPage = graphql`
  query contactPage {
    allWordpressPage {
      edges {
        node {
          slug
          acf {
            page_reference
            hero_title
            hero_text
            hero_background {
              localFile {
                childImageSharp {
                  sizes {
                    originalImg
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/page-contact.js